export function formatFqnForDatabricks(fqn: string) {
  return fqn
    .split('.')
    .map((part) => {
      if (!part.startsWith('`') || !part.endsWith('`')) {
        return `\`${part}\``
      }
      return part
    })
    .join('.')
}
